module.exports = __webpack_public_path__ + "media/images/fm_8-24345aa6e7798cca784fdece462efb61.png";